export enum EUnit {

    Pourcentage = 1,
    m2 = 2,
    cm2 = 3,

}